import React, { useEffect, useState } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FaBriefcase, FaClipboardList, FaUserFriends } from 'react-icons/fa';
import Sidebar from './Sidebar';
import { Helmet } from 'react-helmet';

const Dashboard = () => {
  const [productCount, setProductCount] = useState(0);
  const [applicationCount, setApplicationCount] = useState(0);
  const [candidate, setCandidate] = useState(0);
  const firestore = getFirestore();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  const fetchProductCount = async () => {
    try {
      const productsSnapshot = await getDocs(collection(firestore, 'Products'));
      setProductCount(productsSnapshot.size);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchApplicationCount = async () => {
    try {
      const applicationSnapshot = await getDocs(collection(firestore, 'applications'));
      setApplicationCount(applicationSnapshot.size);
    } catch (error) {
      console.error('Error fetching applications:', error);
    }
  };

  const fetchCandidateCount = async () => {
    try {
      const userSnapshot = await getDocs(collection(firestore, 'users'));
      setCandidate(userSnapshot.size);
    } catch (error) {
      console.error('Error fetching candidates:', error);
    }
  };

  useEffect(() => {
    fetchProductCount();
    fetchApplicationCount();
    fetchCandidateCount();
  }, []);

  return (
    <div className="lg:flex h-screen overflow-hidden bg-white">
      <Helmet>
        <title>Dashboard - Nexify Infosystems</title>
        <meta name="description" content="View and manage job listings, job applications, and candidates on the Nexify admin dashboard." />
        <meta name="keywords" content="Nexify, dashboard, jobs, applications, candidates, admin, view jobs, view applications, view candidates" />
      </Helmet>

      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 p-4 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-12px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}
      
        >
        <h1 className="lg:text-2xl text-lg font-bold mb-4">Dashboard</h1>

        {/* Responsive Grid Layout */}
        <div className={`grid gap-4 transition-all duration-300 ${isSidebarOpen ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'}`}>
          
          {/* Jobs Card */}
          <div className="bg-gradient-to-r from-blue-400 to-blue-600 shadow-md rounded-lg p-4 text-center hover:from-blue-500 hover:to-blue-700 transition text-white">
            <div className="text-4xl mb-2">
              <FaBriefcase />
            </div>
            <h2 className="lg:text-lg text-md font-semibold">Total Jobs</h2>
            <p className="lg:text-2xl text-xl font-bold">{productCount}</p>
            <Link to="/viewItems" className="text-white underline mt-2 block">View Jobs</Link>
          </div>

          {/* Job Applications Card */}
          <div className="bg-gradient-to-r from-green-400 to-green-600 shadow-md rounded-lg p-4 text-center hover:from-green-500 hover:to-green-700 transition text-white">
            <div className="text-4xl mb-2">
              <FaClipboardList />
            </div>
            <h2 className="lg:text-lg text-md font-semibold">Total Job Applications</h2>
            <p className="lg:text-2xl text-xl font-bold">{applicationCount}</p>
            <Link to="/view-application" className="text-white underline mt-2 block">View Applications</Link>
          </div>

          {/* Candidates Registered Card */}
          <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 shadow-md rounded-lg p-4 text-center hover:from-yellow-500 hover:to-yellow-700 transition text-white">
            <div className="text-4xl mb-2">
              <FaUserFriends />
            </div>
            <h2 className="lg:text-lg text-md font-semibold">Total Candidates Registered</h2>
            <p className="lg:text-2xl text-xl font-bold">{candidate}</p>
            <Link to="/view-candidate" className="text-white underline mt-2 block">View Candidates</Link>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
